export default "__VITE_ASSET__c5f0df43__"